import { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('access_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('access_token');
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        if (decoded.exp > Date.now() / 1000) {
          setUser({
            id: decoded.id || null,
            nombre: decoded.sub,
            tipo_usuario: decoded.tipo_usuario || null,
          });
          setToken(storedToken);
        } else {
          localStorage.removeItem('access_token');
          setToken(null);
        }
      } catch {
        localStorage.removeItem('access_token');
        setToken(null);
      }
    }
    setLoading(false);
  }, []);

  const login = (newToken) => {
    localStorage.setItem('access_token', newToken);
    setToken(newToken);
    try {
      const decoded = jwtDecode(newToken);
      setUser({
        id: decoded.id || null,
        nombre: decoded.sub,
        tipo_usuario: decoded.tipo_usuario || null,
      });
    } catch {
      localStorage.removeItem('access_token');
      setToken(null);
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
